import { ISecurityPreferencesService } from '../entities/ISecurityPreferencesService';
import { ISecurityPreferencesRepository } from '../entities/ISecurityPreferencesRepository';
import { ChangePasswordAuthorizationResponseBody } from '../entities/ChangePasswordAuthorizationResponseDTO';
import { ChangeUsernameAuthorizationResponseBody } from '../entities/ChangeUsernameAuthorizationResponseDTO';
import { PasswordPolicy, UsernameRule } from '../entities';

export class SecurityPreferencesServiceImpl implements ISecurityPreferencesService {
  itemRepo: ISecurityPreferencesRepository;

  constructor(ir: ISecurityPreferencesRepository) {
    this.itemRepo = ir;

    this.GetChangePasswordAuthorization = this.GetChangePasswordAuthorization.bind(this);
    this.ChangePassword = this.ChangePassword.bind(this);
    this.PasswordPolicy = this.PasswordPolicy.bind(this);
    this.ChangeUsernameAuthorization = this.ChangeUsernameAuthorization.bind(this);
    this.ChangeUsername = this.ChangeUsername.bind(this);
    this.UsernameRule = this.UsernameRule.bind(this);
  }

  GetChangePasswordAuthorization(): Promise<ChangePasswordAuthorizationResponseBody> {
    return this.itemRepo.GetChangePasswordAuthorization();
  }

  ChangePassword(data?: {
    requestId: string;
    currentPassword: string;
    newPassword: string;
    newPasswordConfirmation: string;
  }): Promise<{}> {
    return this.itemRepo.ChangePassword(data);
  }

  PasswordPolicy(): Promise<PasswordPolicy[]> {
    return this.itemRepo.PasswordPolicy();
  }

  ChangeUsernameAuthorization(params: { newUsername: string }): Promise<ChangeUsernameAuthorizationResponseBody> {
    return this.itemRepo.ChangeUsernameAuthorization(params.newUsername);
  }

  UsernameRule(): Promise<UsernameRule[]> {
    return this.itemRepo.UsernameRule();
  }

  ChangeUsername(params: { requestId: string }): Promise<{}> {
    return this.itemRepo.ChangeUsername(params.requestId);
  }
}
